export const NAMESPACE = 'auth'